import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0dceed14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "niceUl" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "liLabel" }, "応募者名", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "liLabel" }, "誕生日", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "liLabel" }, "希望職種", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "liLabel" }, "学校", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "liLabel" }, "電話", -1))
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "liLabel" }, "住所", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "liLabel" }, "自己PR", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "liLabel" }, "職歴", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "liLabel" }, "資格", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_budou_x = _resolveComponent("budou-x")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", null, [
      _hoisted_2,
      _createTextVNode(" " + _toDisplayString(_ctx.data.name) + "(" + _toDisplayString(_ctx.data.furigana) + ")", 1)
    ]),
    _createElementVNode("li", null, [
      _hoisted_3,
      _createTextVNode(" " + _toDisplayString(_ctx.data.birthday) + "(" + _toDisplayString(_ctx.getHowOld(_ctx.data.birthday)) + "歳)", 1)
    ]),
    _createElementVNode("li", null, [
      _hoisted_4,
      _createTextVNode(" " + _toDisplayString(_ctx.getTypeJa(_ctx.data.type)), 1)
    ]),
    _createElementVNode("li", null, [
      _hoisted_5,
      _createTextVNode(" " + _toDisplayString(_ctx.data.univName) + _toDisplayString(_ctx.data.faculty) + _toDisplayString(_ctx.data.grade) + "(年)", 1)
    ]),
    (_ctx.details)
      ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
          _hoisted_7,
          _createTextVNode(" " + _toDisplayString(_ctx.data.tel), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.details)
      ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
          _hoisted_9,
          _hoisted_10,
          _createTextVNode(" " + _toDisplayString(_ctx.data.address), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("li", null, [
      _hoisted_11,
      _hoisted_12,
      _createVNode(_component_budou_x, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.data.prMyself), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("li", null, [
      _hoisted_13,
      _hoisted_14,
      _createVNode(_component_budou_x, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.data.history), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("li", null, [
      _hoisted_15,
      _hoisted_16,
      _createVNode(_component_budou_x, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.data.qualification), 1)
        ]),
        _: 1
      })
    ])
  ]))
}